// Only those that can view customers will see the customer and tlp columns in the result
export const omitFieldsFor = (canViewCustomer) => (fields) => {
    if (canViewCustomer) {
        return fields;
    }
    else {
        return fields.filter((f) => !["customer", "tlp"].includes(f.field));
    }
};
